import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Footer from './components/Footer';
import Snacks from './components/Snacks';
import About from './components/About';
import Contact from './components/Contact';
import Food from './components/Food';
import Drinks from './components/Drinks';
import Profile from './components/Profile';
import Signup from './pages/Signup';
import Login from './pages/Login';
import { useAuthContext } from './hooks/useAuthContext';

function App() {
  const { user } = useAuthContext()
  return (
    <Router>
      <div className="app">
        <Navbar />
        <div className="routes">
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/about' element={<About />} />
            <Route path='/contact' element={<Contact />} />
            <Route path='snacks' element={<Snacks />} />
            <Route path='/food' element={<Food />} />
            <Route path='/drinks' element={<Drinks />} />
            <Route path='/profile'element={<Profile />} />
            <Route path='/signup'element={<Signup />} />
            <Route path='/login'element={<Login />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
